var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.href)?_c('span',{staticClass:"breadcrumb-item"},[_c('a',{staticClass:"text-muted",attrs:{"href":_vm.href}},[_vm._t("default")],2)]):_c('span',{staticClass:"breadcrumb-item active"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }